// extracted by mini-css-extract-plugin
export default {"service-card":"ServiceCard_service-card__wLEyJ","card-image":"ServiceCard_card-image__a9gyi","card-content":"ServiceCard_card-content__9Xx1M"};